// /* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import { Card, InputGroup, Button, Form as BForm } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import AddVideoModal from "./AddVideoModal";
import { getVideoPageData } from "./redux/selectors";
import { reorderDND } from "../../../../utils/commonFunctions";
import { deleteVideo, getData, setSequence } from "./redux/action";
import DeleteModel from "../../coupons/DeleteModal";

function VideoSection() {
  const [generalEdit, setGeneralEdit] = useState(false);
  const [firstRender, setFirstRender] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [editVideo, setEditVideo] = useState<{ id: string | null; title: string; url: string } | null>(null);
  const [show, setShow] = useState(false);
  const [showDelet, setShowDelet] = useState(false);
  const [loader, setLoader] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const timout = setTimeout(() => {
      if (!firstRender) {
        setFirstRender(true);
      } else {
        setSearchLoader(true);
        dispatch(
          getData(() => {
            setSearchLoader(false);
          }, search),
        );
      }
    }, 500);
    return () => clearTimeout(timout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const {
    videos: { data },
  } = useSelector(getVideoPageData);

  const handleShow = (video?: any) => {
    setEditVideo(
      video
        ? {
            id: video.id,
            title: video.title,
            url: video.url,
          }
        : null,
    );
    setShow(true);
  };

  const initialState = {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubmit = (_values?: any) => {
    setGeneralEdit(false);
  };

  function extractVideoId(url: string) {
    // Regular expression pattern to match YouTube video IDs
    const pattern = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(pattern);

    if (match) {
      return match[1];
    }
    return null;
  }

  const handleDelete = (id: number | null) => {
    setLoader(true);
    dispatch(
      deleteVideo(id, () => {
        setLoader(false);
        setShowDelet(false);
      }),
    );
  };

  const handleOnDragEnd = (result: any) => {
    let appData = [...data];
    if (result.destination?.index === 0 || result.destination?.index) {
      appData = reorderDND(data, result?.source?.index, result?.destination?.index);
      dispatch({ type: "CRUD_VIDEOS", payload: appData });
      const formData = new FormData();
      const newSequence = appData.map((item: any) => item.id);
      formData.append("sequence", JSON.stringify(newSequence));
      dispatch(setSequence({ sequence: newSequence }));
    }
  };

  return (
    <>
      <Formik enableReinitialize initialValues={initialState} onSubmit={handleSubmit}>
        <Form>
          {" "}
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h6 className={`mb-0 ${generalEdit ? "editTitle" : ""}`}>Video Info</h6>
              {generalEdit ? (
                <button type="submit" className="btn btn-primary">
                  <i className="fa-regular fa-floppy-disk" /> Save
                </button>
              ) : (
                <span aria-hidden className="btn btn-green" onClick={() => setGeneralEdit(true)}>
                  Edit <i className="fa-regular fa-pen-to-square ms-2" />
                </span>
              )}
            </Card.Header>
            <Card.Body className="position-relative">
              <div className="d-flex">
                <InputGroup>
                  <BForm.Control
                    aria-label="Example text with button addon"
                    placeholder="Search for specific Video"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    value={search}
                    aria-describedby="basic-addon1"
                  />
                  {search ? (
                    <Button onClick={() => setSearch("")} variant="blue" className="btn-icon" style={{ borderRadius: "0 3px 3px 0" }}>
                      <i aria-hidden className="fa fa-xmark cursor-pointer" />
                    </Button>
                  ) : (
                    <Button variant="blue" className="btn-icon" style={{ borderRadius: "0 3px 3px 0" }}>
                      <i aria-hidden className="fa fa-search cursor-pointer" />
                    </Button>
                  )}
                </InputGroup>
                <button type="button" className="btn btn-blue text-nowrap ms-4" onClick={() => handleShow(null)}>
                  Add Video
                </button>
              </div>

              <div className="gy-3">
                {/* <Col xs={12} sm={6} lg={4}>
                  <div className="uploarForm ratio ratio-16x9 position-relative cursor-pointer" style={{ minHeight: "auto" }} >
                    <div className="position-absolute top-50 start-50 translate-middle text-center h-auto">
                      <i className="fa-light fa-upload fa-2x text-primary" />
                      <h6 className="mb-0 mt-3">Add Videos</h6>
                    </div>
                  </div>
                </Col> */}

                <table className="tableStyle mt-4">
                  <thead>
                    <tr>
                      <th className="text-center">No.</th>
                      <th>Video</th>
                      <th>Title</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {!searchLoader && !!data.length && (
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      <Droppable droppableId="optionDrag" direction="vertical">
                        {(provided) => (
                          <tbody className="" {...provided.droppableProps} ref={provided.innerRef}>
                            {data.map((item: any, index: number) => (
                              <Draggable key={`option${item?.id}`} draggableId={`optionDrag${item?.id}`} index={index}>
                                {(providedInner) => (
                                  <tr ref={providedInner.innerRef} {...providedInner.draggableProps}>
                                    {!search && (
                                      <td {...providedInner.dragHandleProps}>
                                        <span className="labelCount ms-3 mt-3 d-flex align-items-center" {...providedInner.dragHandleProps}>
                                          <i className="fa-regular fa-ellipsis-vertical" />
                                          <i className="fa-regular fa-ellipsis-vertical mx-1" /> <strong>{index + 1}</strong>
                                        </span>
                                      </td>
                                    )}
                                    <td {...providedInner.dragHandleProps}>
                                      <div style={{ width: "200px" }}>
                                        <div className="ratio ratio-16x9" {...providedInner.dragHandleProps}>
                                          <iframe
                                            {...providedInner.dragHandleProps}
                                            src={`https://www.youtube.com/embed/${extractVideoId(item?.url)}?controls=0`}
                                            title={item?.title}
                                            allowFullScreen
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td {...providedInner.dragHandleProps}>
                                      <p {...providedInner.dragHandleProps}>{item?.title}</p>
                                    </td>
                                    <td {...providedInner.dragHandleProps}>
                                      <ul className="actionBtns">
                                        <li>
                                          <i
                                            onClick={() => {
                                              setDeleteId(item.id);
                                              setShowDelet(true);
                                            }}
                                            className="fa-regular fa-trash cursor-pointer"
                                          />
                                        </li>
                                        <li>
                                          <i onClick={() => handleShow(item)} className="ms-3 fa-regular fa-edit cursor-pointer" />
                                        </li>
                                      </ul>
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </tbody>
                        )}
                      </Droppable>
                    </DragDropContext>
                  )}
                </table>
                {!searchLoader && !data.length && <div className="text-center">No video found</div>}
                {searchLoader && (
                  <div className="text-center">
                    <div className="spinner-border spinner-border-sm mr-2" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`position-absolute w-100 h-100 start-0 top-0 zIndex-2 ${generalEdit ? "d-none" : ""}`}
                style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed", zIndex: "3" }}
              />
            </Card.Body>
          </Card>
        </Form>
      </Formik>
      {show && <AddVideoModal show={show} setShow={setShow} editVideo={editVideo} setEditVideo={setEditVideo} />}
      <DeleteModel onClick={() => handleDelete(deleteId)} show={showDelet} setShow={setShowDelet} showLoader={loader} name="video" />
    </>
  );
}

export default VideoSection;
